export default __webpack_public_path__ + "a6675989aac1d22844a0465827168b46.png";